<div class="flex items-center">
	<svg class="h-5" fill="currentColor" viewBox="0 0 20 20">
		<path d="M11 0h3L9 20H6l5-20z" />
	</svg>
	<span><slot /></span>
</div>
